<template>
  <w-modal
    v-model="show"
    close-button="Anuluj"
    submit-button="Zapisz"
    title="Dodawanie Etapu"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    @submit="save"
    @close="close"
  >
    <div class="row">
      <div class="form-group col-12">
        <w-input :model="$schema.name" />
      </div>

      <div class="form-group col-12">
        <w-select :values="types" :model="$schema.type" />
      </div>

      <div class="form-group col-12">
        <w-input :model="$schema.eventIds" />
      </div>

      <div class="form-group col-12">
        <w-select :values="modules" :model="$schema.moduleId" />
      </div>
    </div>
  </w-modal>
</template>

<script>
import { mapState } from 'vuex';

import { StageTypeList } from '@/enums/stageType.enum';
import { formMixin } from '@/mixins/form';
import { manageMixin } from '@/mixins/manage';
import schema from '@/schemas/stage.schema';
import { tryParseInt } from '@/utils/number';

const emptyData = () => ({
  name: null,
  type: null,
  module: null,
  eventIds: null
});

// @vuese
// Modal dodania Etapu
// @group Stage
export default {
  mixins: [manageMixin('stage', {}, emptyData), formMixin],
  schema,
  data: () => ({
    model: {},
    types: StageTypeList
  }),
  computed: mapState({
    stateData: state => {
      const stage = state.stage.data;
      return { ...stage, eventIds: stage.eventIds.join(',') };
    },
    modules: state => state.module.list.map(module => ({ text: module.name, value: module.id }))
  }),
  methods: {
    // @vuese
    // Mapowanie listy identyfikatorów przed zapisem
    prepareModel(model) {
      return {
        ...model,
        eventIds:
          (model.eventIds &&
            model.eventIds
              .split(',')
              .map(id => tryParseInt(id.trim()))
              .filter(id => !!id)) ||
          []
      };
    }
  }
};
</script>